var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRegistrationAccountCreated = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 260,
    viewBox: "0 0 400 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10141_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.744 37.2413L127.186 65.595C125.294 65.9967 124.086 67.856 124.488 69.7479L144.261 162.888C144.663 164.78 146.522 165.988 148.414 165.586L281.972 137.233C283.864 136.831 285.072 134.972 284.67 133.08L264.897 39.9397C264.495 38.0477 262.636 36.8396 260.744 37.2413Z",
    stroke: "#071A24",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.5 93.3344L110.308 100.011C108.481 100.646 107.515 102.642 108.151 104.469L139.435 194.399C140.071 196.226 142.067 197.191 143.893 196.556L272.847 151.695C274.674 151.06 275.64 149.064 275.004 147.237L272.139 139",
    stroke: "#071A24",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.504 66.3769L201.684 100.294C203.542 101.098 205.699 100.648 207.065 99.1615L264.613 36.6568L123.504 66.3769Z",
    fill: "#071A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.76 165.929L195.107 88.7136",
    stroke: "#071A24",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.589 137.066L207.423 86.4094",
    stroke: "#071A24",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.959 74.8735C342.099 73.1902 337.639 75.8582 328.978 92.4973C328.474 93.4652 326.996 92.9182 327.248 91.8493C331.599 73.5942 329.978 68.6538 318.411 60.8182C317.605 60.2711 318.075 59.0087 319.041 59.1265C332.901 60.8098 337.361 58.1418 346.022 41.5027C346.526 40.5348 348.004 41.0818 347.752 42.1507C343.401 60.4058 345.022 65.3462 356.589 73.1818C357.395 73.7289 356.925 74.9913 355.959 74.8735Z",
    fill: "#071A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 22C81.1046 22 82 21.1046 82 20C82 18.8954 81.1046 18 80 18C78.8954 18 78 18.8954 78 20C78 21.1046 78.8954 22 80 22Z",
    fill: "#071A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5 93C64.433 93 66 91.433 66 89.5C66 87.567 64.433 86 62.5 86C60.567 86 59 87.567 59 89.5C59 91.433 60.567 93 62.5 93Z",
    fill: "#071A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.5 230C349.985 230 352 227.985 352 225.5C352 223.015 349.985 221 347.5 221C345.015 221 343 223.015 343 225.5C343 227.985 345.015 230 347.5 230Z",
    fill: "#071A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4512 198.688C72.6346 204.139 70.3823 208.455 71.5945 225.973C71.6648 226.997 70.2259 227.281 69.9131 226.304C64.5014 209.605 60.8101 206.463 47.8283 205.88C46.9211 205.84 46.6787 204.596 47.5076 204.218C59.3243 198.767 61.5765 194.451 60.3644 176.933C60.294 175.909 61.7329 175.626 62.0458 176.602C67.4575 193.301 71.1487 196.444 84.1306 197.026C85.0377 197.066 85.2802 198.31 84.4512 198.688Z",
    fill: "#071A24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10141_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 260,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRegistrationAccountCreated);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/registration_account_created.251fdfa49166a94641eb6d963564ff4b.svg";